module.exports = __webpack_public_path__ + "ic-delete.svg?bf9681aceebb11985b2e164a2175bb1b";